import React from 'react'
import * as R from 'remeda'

import { reject } from '~/utils'

import { useTabulatedGroupsAndAll } from '../hooks/useTabulatedGroupsAndAll'
import { useAtomContext, useAtomValueContext } from '../providers/AtomsProvider'

export const useOmitNonTabulatedGroupsDiffs = () => {
  const isTabulated = useAtomValueContext('isTabulated')
  const [groupsDiffs, setGroupsDiffs] = useAtomContext('groupsDiffs')
  const tabulatedGroupsAndAll = useTabulatedGroupsAndAll()

  React.useEffect(() => {
    if (!isTabulated) {
      return
    }

    const notTabulatedGroups = R.pipe(
      groupsDiffs,
      R.flat(),
      R.filter(R.isNot(R.isIncludedIn(tabulatedGroupsAndAll))),
    )
    if (0 < notTabulatedGroups.length) {
      setGroupsDiffs(
        reject(
          (groupsDiff) =>
            0 < R.intersection(groupsDiff, notTabulatedGroups).length,
        ),
      )
    }
  }, [groupsDiffs, isTabulated, setGroupsDiffs, tabulatedGroupsAndAll])
}
